<template>
  <v-data-table
    :loading="isLoading"
    :headers="headers"
    :items="items"
    :mobile-breakpoint="0"
    :items-per-page="itemsPerPage"
    disable-sort
    disable-pagination
    hide-default-footer
    >
    <template v-slot:item.created_at="{ item }">
      <span class="caption">{{ item.created_at | date('MM/DD LT') }}</span>
    </template>
    <template v-slot:item.birthday="{ item }">
      <span class="text-no-wrap">{{ item.birthday }}</span>
    </template>
    <template v-slot:item.nationality="{ item }">
      <span class="text-no-wrap">{{ item.nationality | nationality }}</span>
    </template>
    <template v-slot:item.can_apply="{ item }">
      <p v-if="!item.can_apply" class="mb-0 red--text">NO</p>
      <p v-else-if="item.line_count == 0" class="mb-0 blue--text">YES</p>
      <p v-else class="mb-0 blue--text">{{ `YES(${item.line_count+1})` }}</p>
      <span class="text-no-wrap">{{ item.status ? $t(item.status) : '' }}</span>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn
        v-if="item.can_apply"
        depressed
        small
        outlined
        color="primary"
        :to="{ name: 'apply', params: { no: item.identity_no }}"
      >
        <v-icon left>mdi-credit-card-plus-outline</v-icon>
          {{ $t('辦門號')}}
        </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { date, nationality } from '../libs/filters';
import StatusChip from './StatusChip';
import { mapGetters } from 'vuex';

export default {
  props: {
    isLoading: Boolean,
    items: Array,
    itemsPerPage: {
      default: 15,
    },
  },

  filters: {
    date,
    nationality,
  },

  components: {
    StatusChip,
  },

  computed: {
    headers() {
      return [
        { text: this.$t("日期"), value: 'created_at', width: '20%' },
        { text: this.$t("證號"), value: 'identity_no', width: '30%' },
        { text: this.$t("生日"), value: 'birthday' },
        { text: this.$t("國籍"), value: 'nationality' },
        { text: this.$t("結果"), value: 'can_apply' },
        { text: this.$t("狀態"), value: 'actions' },
      ];
    },

    ...mapGetters(['allowPhoneCount']),
  },

  methods: {
    isEditable(application) {
      return ['on-hold', 'has-issue'].includes(application.status);
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep.v-data-table td, ::v-deep.v-data-table th {
  padding: 0 8px;
}
</style>
